/**
 * file : ScrollToTop .jsx
 * 설명 : 스크롤 최상단 위치
 */

import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {

  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null
}